// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__rwk8u","slideDownAndFade":"tooltip_slideDownAndFade__oz75p"};